// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__17Qqn","Open":"SideDrawer_Open__2CHf5","Close":"SideDrawer_Close__1MKh3","Logo":"SideDrawer_Logo__1rvc2"};